import {
  Component, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges, OnInit,
  AfterViewInit, Renderer2
} from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {NgSelectComponent} from '@ng-select/ng-select';
import {ValidationHandlerService} from '../validation-handler.service';
import {ObjectUtils} from '../../utils/object.utils';
import {DeviceDetectorService} from 'ngx-device-detector';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'achoo-filter-box',
  templateUrl: './achoo-filter-box.component.html',
  styleUrls: ['./achoo-filter-box.component.scss']
})
export class AchooFilterBoxComponent extends AchooInputComponent<any> implements OnChanges, OnInit, AfterViewInit {

  @ViewChild('ngSelect')
  ngSelect: NgSelectComponent;

  @Input()
  public options: any = [];
  @Input()
  public elementDisabled: any = 'disabled';
  @Input()
  public multiple: boolean | false;
  @Input()
  public preventSortingSelection: boolean | false;
  @Input()
  public allowDeselect = true;
  @Input()
  public disabled = false;
  @Input()
  public makeSelectedItemOnTop = true;
  @Input()
  public searchable = true;
  @Input()
  public closeOptionAfterSelecting = true;
  @Input()
  public closeDropdownWithoutFocusing = false;
  @Input()
  public virtualScroll = false;
  @Input()
  tooltipBox: NgbTooltip;

  @Output()
  selectEvent = new EventEmitter<any>();
  @Output()
  openDropDownEvent = new EventEmitter<any>();
  @Output()
  closeDropDownEvent = new EventEmitter<any>();

  constructor(protected validationHandlerService: ValidationHandlerService,
              private devideDetector: DeviceDetectorService,
              protected renderer: Renderer2) {
    super(validationHandlerService);
  }

  ngOnChanges(changes: SimpleChanges) {
    // for the first time change model to re-order selected item on top
    if (changes.model) {
      const hasChangeModel = !ObjectUtils.isEquals(changes.model.currentValue, changes.model.previousValue);
      if (this.makeSelectedItemOnTop && changes.model && hasChangeModel && changes.model.currentValue && changes.model.currentValue.length > 0) {
        // waiting for ng-select rendered
        setTimeout(() => {
          this.orderOptions(this.options);
        }, 1000);
      }
    }
  }

  ngOnInit() {
    super.ngOnInit();
    // disable filter option on mobile
    if (this.devideDetector.isMobile()) {
      this.searchable = false;
    }
  }

  ngAfterViewInit() {
    if (this.ngSelect) {
      const randomId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10);
      this.renderer.setAttribute(this.ngSelect.filterInput.nativeElement, 'id', randomId);
      this.renderer.setAttribute(this.ngSelect.filterInput.nativeElement, 'autocomplete', randomId);
    }
  }

  isSelectedItem() {
    if (!this.options) {
      return false;
    }

    if (!Array.isArray(this.options)) {
      return false;
    }
    let selectedIndex;
    // find the selected option index
    if (this.multiple) {
      selectedIndex = this.options.findIndex(opt => Array.isArray(this.model_) && this.model_.findIndex(val => val === opt.id) >= 0);
    } else {
      selectedIndex = this.options.findIndex(opt => opt.id === this.model_);
    }
    return selectedIndex >= 0;
  }

  numOfSelection() {
    if (this.multiple) {
      return this.model_.length;
    } else {
      return this.model_ ? 1 : 0;
    }
  }

  onSelect(e) {
    this.selectEvent.emit(e);
    if (this.makeSelectedItemOnTop) {
      this.orderOptions(this.ngSelect.items);
    }
  }

  onOpenDopdown(e) {
    this.openDropDownEvent.emit(e);
  }

  onCloseDopdown(e) {
    if (this.closeDropdownWithoutFocusing) {
      this.closeDropDownEvent.emit(e);
    }
  }

  onBlur(e) {
    this.ngSelect.close();
    this.closeDropDownEvent.emit(e);
  }

  onClickOption(id, e) {
    if (this.model_ === id && this.allowDeselect) {
      this.ngSelect.clearModel();
      e.stopPropagation();
    }
  }

  /**
   * using this method to update the ng-Select selected item list directly.
   * When modify the ngModel without using ngSelect events(onSelect, change ...)
   * @param val
   */
  updateModel(val) {
    this.ngSelect.writeValue(val);
  }

  private orderOptions(items) {
    // Variable to hold result depending on sort option
    let newItemList = items;

    // Only sort by selection first if nothing else has been specified
    if (!this.preventSortingSelection) {

      // retrieved list selected items
      const selectedOptionItems = items.filter(item => this.isSelectedOption(item));
      // retrieved list unselected items
      const unSelectedOptionItems = items.filter(item => !this.isSelectedOption(item));

      // display selected items in top of the list option
      newItemList = selectedOptionItems.concat(unSelectedOptionItems);
    }

    // clear selected items first
    this.ngSelect.itemsList.clearSelected();
    // updated the new ordered list option
    this.ngSelect.itemsList.setItems(newItemList);
    // marked selected for previous selected items
    this.ngSelect.itemsList.items.forEach(item => {
      if (this.isSelectedOption(item.value)) {
        this.ngSelect.itemsList.select(item);
      }
    });
  }

  private isSelectedOption(option) {
    if (this.multiple) {
      return this.model_.findIndex(val => val === option.id) >= 0;
    } else {
      return this.model_ === option.id;
    }
  }

  onMouseOver() {
    if (!this.tooltipBox) {
      return;
    }
    this.tooltipBox.disableTooltip = this.ngSelect.isOpen;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-filter-box/achoo-filter-box.component.ts